import { ExternalLink } from '@/6_shared/config'

export type FAQLink = {
  title: string
  description?: string
  to: ExternalLink | string
  external?: boolean
}

export const FAQLinks: FAQLink[] = [
  {
    title: 'FAQ / частые вопросы',
    description: '',
    to: '/settings/faq'
  },
  {
    title: 'Как вернуть билет',
    description: 'если изменились планы,<br/> или отменили мероприятие',
    external: true,
    to: ExternalLink.refund
  },
  {
    title: 'Как восстановить билет',
    description: 'если билеты не пришли,<br/> на&nbsp;электронную почту',
    external: true,
    to: ExternalLink.resend
  },
  {
    title: 'Правовая информация',
    external: true,
    to: ExternalLink.oferta
  },
  {
    title: 'Написать нам сообщение',
    description: 'и задать свой вопрос',
    external: true,
    to: ExternalLink.feedback
  }
]
